import {Enumify} from "enumify-ts";

class FreightBulkMeasureType extends Enumify<FreightBulkMeasureType>() {

    static WEIGHT_TON = new FreightBulkMeasureType("Tonne");
    static VOLUME_CUBIC_METERS = new FreightBulkMeasureType("Cubic Metres");
    static AREA_SQUARE_METRES = new FreightBulkMeasureType("Square Metres");
    static DURATION_HOURS = new FreightBulkMeasureType("Hours");
    static VOLUME_LITRES = new FreightBulkMeasureType("Litres");
    static _ = FreightBulkMeasureType._closeEnum();

    constructor(
        public description: string
    ) {
        super();
    }

    showNetQty() {
        switch (this) {
            case FreightBulkMeasureType.WEIGHT_TON:
                return true;
            default:
                return false;
        }
    }

}

export default FreightBulkMeasureType;
